module.exports = __webpack_public_path__ + "img/background_light_dimmed.452bc0a4.png";